import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.png'


const _withScopeId = n => (_pushScopeId("data-v-aa616888"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy-background-tiered-points" }, null, -1))
const _hoisted_2 = { class: "modal-dialog-tiered-points" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "slide-bar" }, null, -1))
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-header-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "คอยน์ใกล้หมดอายุ", -1))
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "modal-item" }
const _hoisted_13 = { class: "coin" }
const _hoisted_14 = { class: "date" }
const _hoisted_15 = {
  key: 0,
  class: "line"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    class: "modal-bottom-tiered-points-section",
    style: _normalizeStyle({ zIndex: _ctx.active ? 10001 : 2000 })
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["modal-bottom-tiered-points modal-show-bar-qr-code-x", {show: _ctx.active}]),
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
                }, _hoisted_10)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tieredPoints, (item, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getLabelPoints(item.expiringPoints)), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getLabelDate(item.date)), 1)
                ]),
                (index !== _ctx.tieredPoints.length - 1)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ])
        ])
      ])
    ], 2)
  ], 4))
}